import React, { useState } from 'react'
import styles from './styles.module.css'

function RawCategories ({ record }) {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  const categoriesToShow = isExpanded
    ? record.categories
    : record.categories?.slice(0, 3) || []

  return (
    <div className={styles.rawCategoriesContainer}>
      <h1 className={styles.rawCategoriesTitle}>Raw categories</h1>

      <div className={styles.rawCategoriesList}>
        {categoriesToShow.length > 0 ? (
          categoriesToShow.map((category, index) => (
            <span key={index} className={styles.rawCategoriesItem}>
              {category}
            </span>
          ))
        ) : (
          <span className={styles.noRawCategories}>N/A</span>
        )}
      </div>

      {record.categories && record.categories.length > 3 && (
        <button className={styles.rawCategoriesButton} onClick={toggleExpand}>
          {isExpanded
            ? 'Show less'
            : `Expand all (${record.categories.length})`}
        </button>
      )}
    </div>
  )
}

export default RawCategories
